import type { PageTheme } from './types';
import { autoColor } from 'shared/colors';
import { MenuChoice } from '@course/components/page-builder/settings-menu/core';
import { CTARadius } from '@course/components/page-builder/settings-menu';
import { ColorOptions } from '@course/components/page-builder/settings-menu/color-options';

export function ButtonsPanel({
  theme,
  setTheme,
}: {
  theme: PageTheme;
  setTheme(theme: PageTheme): void;
}) {
  const roundingChoices: CTARadius[] = ['none', 'small', 'medium', 'large', 'full'];
  return (
    <div class="flex-1 p-6">
      <div class="mb-6">
        <h3 class="text-lg font-semibold mb-2">Call To Action Buttons</h3>
        <p class="text-sm text-gray-600 mb-4">
          Set the default styling for all call to action buttons on your page. Individual buttons
          can override these settings.
        </p>
      </div>

      <section class="border rounded-2xl p-4">
        <ColorOptions
          label="Background"
          name="bgcolor"
          value={theme.cta?.bgcolor}
          onChange={(bgcolor) =>
            setTheme({ ...theme, cta: { ...theme.cta, bgcolor, fgcolor: autoColor(bgcolor) } })
          }
        />
        <ColorOptions
          label="Text"
          name="fgcolor"
          value={theme.cta?.fgcolor}
          onChange={(fgcolor) => setTheme({ ...theme, cta: { ...theme.cta, fgcolor } })}
        />
        <MenuChoice
          label="Rounding"
          choices={roundingChoices}
          name="borderRadius"
          value={theme.cta?.borderRadius}
          onChange={(borderRadius) => setTheme({ ...theme, cta: { ...theme.cta, borderRadius } })}
          choiceUi={(option) => {
            switch (option) {
              case 'small':
                return 'SM';
              case 'medium':
                return 'MD';
              case 'large':
                return 'LG';
              case 'full':
                return 'XL';
              default:
                return option;
            }
          }}
        />
      </section>
    </div>
  );
}
